
import { Vue } from "vue-class-component";

export default class Grid extends Vue {}
